export function normalizeStorefrontHref(value) {
  const raw = String(value || '').trim();
  if (!raw || /[\u0000-\u001f\u007f]/.test(raw)) return '';
  if (/^(https?:|mailto:|tel:)/i.test(raw)) return raw;
  if (/^[a-z][a-z\d+.-]*:/i.test(raw)) return '';
  if (/^www\./i.test(raw)) return `https://${raw}`;
  if (/^[/?#]/.test(raw)) return raw;
  return `/${raw.replace(/^\.\//, '')}`;
}
